import { HekateExternalUtil } from '@onshape/www-inertia';

export default function useSiteLang() {
  const lang = computed(() => {
    if (import.meta.server) {
      return 'en';
    }
    return HekateExternalUtil.getLanguage();
  });

  return { lang };
}
